import { type HeadingProps, Heading as RadixHeading } from "@radix-ui/themes";

export function Heading(props: HeadingProps) {
  return <RadixHeading {...props} />;
}
